import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography'
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { CSSObject, DialogTitle } from '@mui/material';
import { IComponentCss } from '@tap/mui-ui';


/*
*   Корневой элемент диалога
*/
type IDialogCustom = {
    children?: React.ReactNode,
    open: boolean,
    sx?: CSSObject,
    dialogMinWidth?: string,
    dialogMaxWidth?: string,
    isDisableClickAwayOnClose?: boolean,
    handleClose?: () => void,
}

export function DialogCustom({
    children,
    open,
    sx = undefined,
    dialogMinWidth = undefined,
    dialogMaxWidth = '810px',
    handleClose,
    isDisableClickAwayOnClose = false,
}: IDialogCustom) {

    return (
        <Dialog
            onClose={() => {
                !isDisableClickAwayOnClose && !!handleClose && handleClose()
            }}
            open={open}
            sx={{
                '& .MuiDialog-paper': { minWidth: dialogMinWidth, maxWidth: dialogMaxWidth, dialogMinWidth, width: '100%' },
                ...sx,
            }}
        >
            {/* Кнопка закрытия диалога */}
            {handleClose ? (
                <IconButton
                    aria-label='close'
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}

            {children}
        </Dialog>
    );
}


/*
*   Заголовок диалогового окна
*/
type IDialogTitleCustom = {
    primaryText: string,
    secondaryText?: string,
}

const cssTitle: IComponentCss = {
    wrap: {
        m: 0,
        p: 2,
        overflow: 'hidden',
    },
    primaryText: {
        m: 0,
        padding: '0px 40px 0px 0px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    secondaryText: {
        m: 0,
        p: 0,
        color: '#666666',
        fontSize: '14px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
}

export function DialogTitleCustom({ primaryText, secondaryText }: IDialogTitleCustom) {

    return (
        <DialogTitle component={'div'}>
            <Typography
                component='h6'
                variant='h6'>{primaryText}</Typography>

            {!!secondaryText &&
                <Typography sx={cssTitle.secondaryText} component='p'>{secondaryText}</Typography>
            }
        </DialogTitle>
    );
}